// bonus services

export const get = function (user, token, $=this) {
  return $.$api
    .get('/getbonus/'+user+'/'+token)
    .then(response => {
      console.log('getBonus => ',response);
      if(response.data.retorno==200){
        const prefix = response.data.prefixo;
        const list = JSON.parse(response.data.list);
        let items = [];
        for (let item in list) {
          items.push({
            id: list[item].id,
            dateDraw: list[item].dsc,
            dateOpen: $.$moment.utc(list[item].dt_abertura, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD'),
            dateClosed: list[item].dt_fechamento !== null ? $.$moment.utc(list[item].dt_fechamento, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD') : null,
            tickets: list[item].tickets,
            ticketsTotal: list[item].tickets_used,
            prizes: []
          });
          const prizes = list[item].premios;
          for (let p in prizes) {
            items[item].prizes.push({
              id: prizes[p]['id-premio'],
              title: prizes[p]['dsc-premio'],
              winner: prizes[p]['winner']
            });
          }
        }
        return { items, prefix };
      }else if(response.data.retorno==401){
        $.getout();
        $.toggleToast(
          true,
          $.$t('errors.session_expired'),
          5000,
          false
        );
      }else{
        $.toggleToast(
          true,
          $.$t('bonus.error.get'),
          5000,
          false
        );
      }
    })
    .catch(error => {
      $.handleError(error, 'Não foi possível atualizar a lista de sorteios. Verifique sua conexão à internet', true);
    })
}

export default {
  get,
}